import React from "react";

const RadioGroup = ({
  handleChange,
  inputFocus,
  label,
  inputClassName,
  name,
  value_1,
  value_2,
  checked_1,
  checked_2,
  datagroup,
  dataBsToggle,
  dataBsTarget,
  isNotRequired,
}) => {
  return (
    <>
      <label className="fw-bold mb-2" htmlFor={name}>
        {label}&nbsp;
        {isNotRequired && <span className="text-danger">(facultatif)</span>}
        <span className={`${isNotRequired ? "d-none" : "text-danger"}`}>*</span>
      </label>
      <div className="form-check">
        <input
          className={"form-check-input radio-group getLabel " + inputClassName}
          type="radio"
          name={name}
          id={name}
          value={value_1}
          onChange={handleChange}
          onInput={inputFocus}
          datagroup={datagroup}
          checked={checked_1}
          data-bs-toggle={dataBsToggle}
          data-bs-target={dataBsTarget}
        />
        <label className="form-check-label">{value_1}</label>
      </div>
      <div className="form-check position-relative">
        <input
          className={"form-check-input radio-group getLabel " + inputClassName}
          type="radio"
          name={name}
          id={name}
          value={value_2}
          onChange={handleChange}
          onInput={inputFocus}
          datagroup={datagroup}
          checked={checked_2}
        />
        <label className="form-check-label">{value_2}</label>
        <div className="invalid-tooltip">
          Veuillez remplir ce champs obligatoire
        </div>
      </div>
    </>
  );
};

export default RadioGroup;
